import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend,CategoryScale,LinearScale,BarElement, Title } from 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import { CommonUtilities } from "../../commonUtils";
ChartJS.register(ArcElement, Tooltip, Legend);

export default function VerticalBarChart(chartPassedData: any) {
  console.log(chartPassedData);

  const options = {
    ...chartPassedData?.chartPassedData?.options,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      ...chartPassedData?.chartPassedData?.options?.plugins,
    },
    scales: {
      ...chartPassedData?.chartPassedData?.options?.scales,
      x: {
        ...chartPassedData?.chartPassedData?.options?.scales?.x,
        grid: {
          ...chartPassedData?.chartPassedData?.options?.scales?.x?.grid,
          display: false,
        },
        ticks: {
          ...chartPassedData?.chartPassedData?.options?.scales?.x?.ticks,
          autoSkip: false,
          maxRotation: 25,
          minRotation: 25,
          padding: 8,
        },
      },
      y: {
        ...chartPassedData?.chartPassedData?.options?.scales?.y,
        beginAtZero: true,
        ticks: {
          ...chartPassedData?.chartPassedData?.options?.scales?.y?.ticks,
        },
      },
    },
  };

  return (
    <div className="ws-12">
      {chartPassedData?.chartPassedData?.data?.labels?.length > 0 && (
        <div
          style={{
            ...CommonUtilities.parseStyleString(chartPassedData?.style),
            height: "320px",
            width: "100%",
          }}
        >
          <Bar
            options={options}
            data={chartPassedData?.chartPassedData?.data}
          />
        </div>
      )}

      {chartPassedData?.chartPassedData?.data?.labels?.length === 0 && (
        <span className="text-center text-bold ws-12 mtl grey">
          No Data Available.
        </span>
      )}
    </div>
  );
}